export const NAME = 'agentProfile'
